var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["BtnClose.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
[], 
["tag", "link"], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("tag", kwargs.hasOwnProperty("tag") ? kwargs["tag"] : "button");
frame.set("link", kwargs.hasOwnProperty("link") ? kwargs["link"] : "");
var t_2 = "";t_2 += "<";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "tag"), env.opts.autoescape);
t_2 += " class=\"BtnClose u-Btn\" ";
if(runtime.contextOrFrameLookup(context, frame, "link")) {
t_2 += "href=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "link"), env.opts.autoescape);
t_2 += "\"";
;
}
t_2 += ">\n        ";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("require").call(context, "front/components/BtnClose/BtnClose.svg")), env.opts.autoescape);
t_2 += "\n    </";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "tag"), env.opts.autoescape);
t_2 += ">";
t_2 += runtime.suppressValue((lineno = 3, colno = 19, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("BtnClose");
context.setVariable("BtnClose", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["BtnClose.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/BtnClose/BtnClose.jinja
// module id = 58
// module chunks = 0